import React from 'react';
import { Slider } from '@material-ui/core';
import CustomFormInput from './CustomFormInput';

export default class CustomSlider extends CustomFormInput {
    _onChange(event, value) {
        if(this.props.onChangeText)
            this.props.onChangeText(value);
    }
    
    getElement() {
        let props = this.getSupportedProps();

        return <Slider onChange={this._onChange} {...props} />;
    }
}